import { motion } from "framer-motion";
import { Overline } from "./primitives";
import ConceptTag from "./ConceptTag";

const EASE = [0.16, 1, 0.3, 1];

export default function PageHeader({ overline, title, intro, image, concept = false }) {
  return (
    <header className="relative overflow-hidden border-b border-white/10 bg-rp-bg pt-[72px]" data-testid="page-header">
      {image && (
        <>
          <div className="absolute inset-0">
            <img src={image} alt="" aria-hidden="true" className="h-full w-full object-cover opacity-25" />
          </div>
          <div className="absolute inset-0 bg-gradient-to-t from-rp-bg via-rp-bg/70 to-rp-bg/30" />
          {concept && <ConceptTag className="absolute right-6 top-28 md:right-12" />}
        </>
      )}
      <div className="relative mx-auto max-w-7xl px-6 py-20 md:px-12 md:py-28">
        <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7, ease: EASE }}>
          <Overline>{overline}</Overline>
        </motion.div>
        <motion.h1
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: EASE, delay: 0.08 }}
          className="mt-6 max-w-4xl font-display text-4xl font-light uppercase leading-[0.95] tracking-tight text-white sm:text-5xl md:text-6xl lg:text-7xl"
        >
          {title}
        </motion.h1>
        {intro && (
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, ease: EASE, delay: 0.16 }}
            className="mt-8 max-w-2xl text-base leading-relaxed text-white/60 md:text-lg"
          >
            {intro}
          </motion.p>
        )}
      </div>
    </header>
  );
}
